<template>
  <div>
    <div class="header"></div>
    <div class="logo-box w">
      <!-- logo S -->
      <div class="logo fl">
        <router-link to="/" style="display: block">
          <img src="../../assets/img/logo.png" alt />
        </router-link>
      </div>
      <div class="fl fenge"></div>
      <h2 class="fl">新規登録画面</h2>
      <!-- logo E -->
    </div>
    <div class="main w">
      <h2>登録成功いたしました。</h2>
      <p>
        ＊担当者よりチャットワークのフレンド申請がございますので、専用グループ作成まで新規注文は可能ですが、
      </p>
      <p>見積もり作業さいたしませんので、予めご了承ください</p>
      <!-- 同步1688 -->
      <div class="synchronization">
        <div class="text">
          RAKUMARをご利用いただきありがとうございます。この度弊社と中国アリババグループの提携により、弊社での登録携帯番号で１６８８，タオバオのアカウント新規登録できるサービスを提供しており、必要の場合は連結ボタンをクリックして進めてことが可能です。
          よろしくお願いします。</div>
        <div class="website">
          <img src="../../assets/img/1688/1688.png" alt="">https://www.1688.com/
        </div>
        <div class="website">
          <img src="../../assets/img/1688/taobao.png" alt="">https://www.taobao.com/
        </div>
        <div class="website">
          <img src="../../assets/img/1688/tmall.png" alt="">https://www.tmall.com/
        </div>
        <div class="detail">アカウント連結について <router-link to="/accountSynchronization" target="_blank"><span>
              詳細へ</span></router-link> </div>
        <!-- <span class="promptly"> 今すぐ連結へ</span> -->
      </div>
      <router-link to="/user/index" style="color: #fff; background: #f3c622" class="btn">トップページへ</router-link>
      <router-link to="/" class="btn">マイページへ</router-link>
    </div>
    <Foot></Foot>

  </div>
</template>
<script>
import Foot from "../../components/foot/Foot";

export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    Foot,

  },
};
</script>
<style lang='scss' scoped>
.header {
  height: 30px;
  width: 100%;
  background: #eee;
}

.logo-box {
  height: 155px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;

  .logo {
    width: 140px;
    height: 104px;
    margin: 25px 85px 25px 25px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .fenge {
    height: 40px;
    width: 2px;
    background: #ccc;
    margin: 55px 60px 0 0;
  }

  h2 {
    line-height: 155px;
    font-size: 30px;
    font-weight: 700;
    color: #333;
  }
}

.main {
  overflow: hidden;

  text-align: center;
  padding-bottom: 120px;

  h2 {
    font-size: 30px;
    font-weight: 700;
    margin: 120px 0 30px;
  }

  p {
    font-weight: 700;
    font-size: 14px;
    color: #aaa;
    margin-bottom: 30px;
  }

  .synchronization {
    padding: 43px 100px;
    width: 515px;
    background: #F6F6F6;
    border-radius: 3px;
    margin: 40px auto 60px;
    text-align: left;
    font-size: 14px;

    .text {
      font-size: 14px;
    }

    .website {
      margin-top: 20px;

      img {
        vertical-align: middle;
        margin-right: 15px;
      }
    }

    .detail {
      color: #999999;
      margin: 20px 0;

      span {
        cursor: pointer;
        color: #333;
        text-decoration: underline;
      }

    }

    .promptly {
      color: #B4272B;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .btn {
    margin-left: 20px;
    display: inline-block;
    height: 40px;
    width: 200px;
    text-align: center;
    line-height: 40px;
    background: #ddd;
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>